<input
  type="{{ type }}"
  class="{{ class }}"
  [class.no-stepper]="noStepper"
  id="{{ name }}"
  [readonly]="readonly"
  [formControl]="control"
  mask="{{ mask }}"
  maxlength="{{ maxLength }}"
  minlength="{{ minLength }}"
  placeholder="{{ placeholder }}"
  required="{{ required }}"
  [class.is-invalid]="
    (control?.touched || submitted) && required && control?.invalid
  "
/>
